import { render, staticRenderFns } from "./ren-task-back.vue?vue&type=template&id=5eb139ad&"
import script from "./ren-task-back.vue?vue&type=script&lang=js&"
export * from "./ren-task-back.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports